// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"ManageTemplates_buttonContainer__G7NDR","addButton":"ManageTemplates_addButton__1XiND"};